import React, {useRef,useCallback, useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {ProgressDialog, TextDialog} from "../dialogs";
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import HistoryIcon from '@material-ui/icons/History';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import DeleteIcon from '@material-ui/icons/Delete';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import SortIcon from '@material-ui/icons/Sort';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import {
  Box,
  Card,
  CardHeader,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormHelperText,
  Grid,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import { DraggableDialog, PromptDialog } from '../dialogs';
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  dialog,
  ipcRenderer,
  fs,
  getTempFilePath,
  shell,
  tempDirectoryPath
} from '../electron-modules';
import { changeSwitched } from "../redux/settings-slice";
import { ArrowTooltip } from '../tooltips';
import { DenseDivider, IconToolBar, SlimScrollbar, ToolBarButton } from '../toolbar';
import slash from 'slash';
import { PythonExecutable } from '../executable';
import { Viewer } from '../viewer/js/main';
import LocalScene from '../viewer/js/projections';
import { FixedSizeList } from "react-window";
import { LinearProgressWithLabel } from '../progress';
import path from 'path';
import { EnhancedIconButton } from '../buttons';
import { AssetType, deleteAsset, getCameraFileAssets, getPointCloudAssets, selectAllAssets } from '../redux/assets-slice';
import { addPointCloudFiles } from '../asset-utils';
import { selectDefaultFolder } from '../redux/folders-slice';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import Button from '@material-ui/core/Button/Button';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import Select from '@material-ui/core/Select/Select';
import EnhancedTable from '../enhanced-table';
import { nanoid } from '@reduxjs/toolkit';
import { exportCamerasToCSV } from '../folder';
import { throttle } from 'throttle-debounce';
import { selectName } from '../redux/project-slice';
import {
  FileWithLabel,
  FolderWithLabel,
  NumberField,
  NumberFieldWithUnits,
  DraggableList
} from '../components';
import Paper from '@material-ui/core/Paper';
import { DropResult } from 'react-beautiful-dnd';
import { toast } from '../app';
import clsx from 'clsx';
import {
  ImageLabel,
  LabelCategory,
  textToColor,
  getClassFromAlias,
  TrainingAreaLabel
} from '../viewer/js/labelling';

const labelExtension = "3dl";
const modelExtension = "pth";
const dxfExtension = "dxf";
const shpExtension = "shp";
const zipExtension = "zip";

const labelFilter = [{
  name: 'Engine Label File',
  extensions: [labelExtension]
}];

const modelFilter = [{
  name: 'Engine Trained Model File',
  extensions: [modelExtension]
}];

const drawingFilter = [{
  name: 'Drawing Files',
  extensions: [dxfExtension, shpExtension, zipExtension]
}];

const dxfFilter = [{
  name: 'DXF File',
  extensions: [dxfExtension]
}];

const shpFilter = [{
  name: 'SHP File',
  extensions: [shpExtension]
}];

enum LabelImportType {
  Ignore="__ignore",
  Default="__default"
}

const labelHeight = 53;
const geometryLimit = 1000;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleClose: {
      position: 'absolute',
      right: theme.spacing(0),
      color: theme.palette.grey[500],
    },
    titleInfo: {
      position: 'absolute',
      right: theme.spacing(4),
      marginTop: theme.spacing(0),
      color: theme.palette.grey[500],
    },
    titleMin: {
      position: 'absolute',
      right: theme.spacing(4),
      marginTop: theme.spacing(-1),
      color: theme.palette.grey[500],
    },
    userWarning: {
      padding: theme.spacing(3)
    },
    marginTop: {
      marginTop: theme.spacing(2)
    },
    box: {
      padding: theme.spacing(4)
    },
    formControl: {
      width: '100%'
    },
    listContent: {
      margin: theme.spacing(0),
      padding: theme.spacing(0)
    },
    categoryName: {
      flex: 1
    },
    success: {
      color: theme.palette.success.main
    },
    warning: {
      color: theme.palette.warning.main
    },
    error: {
      color: theme.palette.error.main
    },
    info: {
      color: theme.palette.info.main
    },
    folderList: {
      padding: "0px",
      overflow: "auto",
      flex: 1,
      alignItems: "center",
      justifyContent: "center"
    },
    headerTitle: {
      fontWeight: "bold",
      cursor: "pointer"
    },
    cardHeader: {
      padding: "10px"
    },
    cardButtons: {
      marginTop: 0,
      alignSelf: "center"
    },
    labelFixedHeight: {
      height: `${labelHeight}px`
    },
    labelParent: {
      flex: 1,
      userSelect: "none",
      display: "flex",
      flexDirection: "column"
    },
    labelTitleWarning: {
      color: theme.palette.warning.main
    },
    labelTitleError: {
      color: theme.palette.error.main
    },
    classificationText: {
      fontSize: "0.6rem"
    },
    card: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
      userSelect: "none"
    },
    progressToolbar: {
      display: "flex",
      marginLeft: "12px",
      marginRight: "12px"
    },
    toolbarLinear: {
      margin: "auto 12px"
    },
    toolbarProgressCenter: {
      top: "50%",
      height: "6px",
      marginTop: "-3px"
    },
    downloadMargin: {
      marginTop: theme.spacing(1)
    },
    downloadResourceDialog: {
      paddingTop: theme.spacing(2.5),
      paddingBottom: theme.spacing(2.5),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    },
    mixedDataWarning: {
      padding: theme.spacing(2.0),
      color: theme.palette.warning.main
    },
    tableDropdown: {
      fontSize: "0.875rem",
      width: "100%"
    },
    checkBoxWithLabel: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    toggleOptionFlex: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    toggleOptionCheckbox: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    },
    mappingMargin: {
      marginBottom: "3px"
    },
    checkBoxParent: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    tablePadding: {
      paddingTop: theme.spacing(4)
    },
    paddingBottom: {
      paddingBottom: theme.spacing(3),
      display: "block"
    },
    paddingTop: {
      paddingBottom: theme.spacing(0),
      paddingTop: theme.spacing(2),
      display: "block"
    },
    captionPadding: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(0.5),
      display: "block"
    },
    paddingBottomAndTop: {
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
      display: "block"
    },
    paddingBottomAndTopMinimal: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      display: "block"
    },
    fileButtonDiv: {
      paddingTop: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    outputFolder: {
      paddingBottom: theme.spacing(4)
    },
    selectDivider: {
      margin: theme.spacing(0.5),
      opacity: 0.2
    },
    labelExportGrid: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      "& span": {
        flex: 1
      }
    },
    infoLabel: {
      fontWeight: "bold",
      paddingRight: theme.spacing(0.5)
    },
    flexPaper: {
      flex: 1,
      margin: 16,
      minWidth: 350
    },
  }),
);

const getCombinedExtension = (name, filters) => {
  let extensions = [];
  filters.forEach(filter => {
    if (!filter) {
      return;
    }

    filter.forEach(x => {
      extensions = [...extensions, ...x.extensions];
    });
  });

  return {name, extensions};
};

const Label = (props) => {
  const viewer = props.viewer as Viewer;
  const label = props.label as ImageLabel;

  const {index, isScrolling, style, labelName, isSceneLabel} = props;
  const [getInfo, setGetInfo] = useState(false);

  const classes = useStyles();
  const selected = label.selected;
  const completed = label.completed;
  const isTrainingLabel = label instanceof TrainingAreaLabel;

  const scoreClass = () => {
    let scoreValidity = classes.success;
    if (label.score < 0.9) {
      scoreValidity = classes.warning;
    }
    if (label.score < 0.7) {
      scoreValidity = classes.error;
    }
    return scoreValidity;
  };

  const getInfoLabel = () => {
    setGetInfo(true);
  };

  const deleteLabel = (id) => {
    viewer?.deleteLabel(id);
  };

  const zoomToLabel = (id) => {
    viewer?.zoomToLabel(id);
  };

  const unHighlight = (id) => {
    viewer?.unHighlight(id);
  };

  return (
    <ListItem selected={selected} style={style} className={classes.labelFixedHeight}>
      <div className={classes.labelParent}>
        {/** Label number */}
        <Typography variant="caption" className={clsx("", {
          [classes.labelTitleError]: !label.valid,
          [classes.labelTitleWarning]: label.valid && label.highlighted
        })}>
          {`${labelName} #${index + 1} (${label.numPoints})`}
        </Typography>

        {/** Classification score */}
        {!isTrainingLabel && (<div>
          <Typography variant="caption" className={classes.classificationText}>
            Classification Score:
          </Typography>

          <Typography variant="caption" className={clsx(scoreClass(), classes.classificationText)}>
            {label.score.toFixed(2)}
          </Typography>
        </div>)}
      </div>

      {isScrolling && (<React.Fragment>
        <Typography variant="caption">
          Loading...
        </Typography>
      </React.Fragment>)}

      {!isScrolling && (<React.Fragment>

        {/*Classification Score*/}
        <EnhancedIconButton
          visible={completed && !isTrainingLabel}
          title={`Classification Score`}
        >

        </EnhancedIconButton>

        {/* Warning on Label */}
        <EnhancedIconButton
          title={`${labelName} is invalid, will not be exported`}
          visible={completed && (!label.valid)}
        >
          <WarningIcon fontSize="small" className={classes.error}/>
        </EnhancedIconButton>

        {/* Highlighted Label */}
        <EnhancedIconButton
          title={`${labelName} was highlighted, click to remove highlight`}
          visible={completed && (label.highlighted)}
          onClick={() => {
            unHighlight(label.id);
          }}
        >
          <PriorityHighIcon fontSize="small" className={classes.warning}/>
        </EnhancedIconButton>

        {/* Info on Label */}
        <EnhancedIconButton
          title={`${labelName} Information`}
          visible={completed && !isTrainingLabel}
          onClick={() => getInfoLabel()}
        >
          <InfoIcon fontSize="small"/>
        </EnhancedIconButton>

        {/* Zoom to extent */}
        <EnhancedIconButton
          title={`Zoom to ${labelName}`}
          visible={completed}
          onClick={() => {
            zoomToLabel(label.id);
          }}
        >
          <ZoomInIcon fontSize="small"/>
        </EnhancedIconButton>

        {/* Delete Label */}
        <EnhancedIconButton
          title={`Delete ${labelName}`}
          onClick={() => {
            deleteLabel(label.id);
          }}
        >
          <CloseIcon fontSize="small" className={classes.error}/>
        </EnhancedIconButton>

        {/* Label Info */}
        <GetInfoWindow
          open={getInfo}
          setOpen={setGetInfo}
          label={label}
          index={index + 1}
          viewer={viewer}
          isSceneLabel={isSceneLabel}
        />
      </React.Fragment>)}
    </ListItem>
  );
};

const CategoryContent = (props) => {
  const viewer = props.viewer as Viewer;
  const category = props.category as LabelCategory;

  const {labelName, idx, isSceneLabel} = props;

  const classes = useStyles();

  const listRef = useRef(null);

  const scrollingDivLength = category.labels.length;
  const useScrollingDiv = scrollingDivLength > 5;
  const scrollingDivHeight = Math.min(scrollingDivLength*labelHeight, 250);

  useEffect(() => {
    if (listRef) {
      if (listRef.current){
        listRef.current.scrollToItem(idx);
      }
    }
  }, [idx, listRef]);

  return (<React.Fragment>
    {/* Use normal list for small labels list */}
    {!useScrollingDiv && (<React.Fragment>
      <List className={classes.folderList}>
        {category.labels.map((label, index) =>
          <Label
            key={label.id}
            viewer={viewer}
            isScrolling={false}
            label={label}
            index={index}
            labelName={labelName}
            isSceneLabel={isSceneLabel}
          />
        )}
      </List>
    </React.Fragment>)}

    {/* Use scrolling list for large amounts of labels */}
    {useScrollingDiv && (<React.Fragment>
      <FixedSizeList
        ref={listRef}
        useIsScrolling
        className={classes.formControl}
        height={scrollingDivHeight}
        itemCount={scrollingDivLength}
        itemSize={labelHeight}
      >
        {({index, isScrolling, style}) => (
          <Label
            key={category.id}
            style={style}
            viewer={viewer}
            isScrolling={isScrolling}
            label={category.labels[index]}
            index={index}
            labelName={labelName}
            isSceneLabel={isSceneLabel}
          />
        )}
      </FixedSizeList>
    </React.Fragment>)}
  </React.Fragment>);
};

const CategoryExpand = (props) => {
  const {setExpanded, expanded} = props;

  return (<EnhancedIconButton
    title={expanded? "Collapse" : "Expand"}
    onClick={(event) => {
      event.stopPropagation();
      setExpanded(!expanded);
    }}
  >
    {expanded && <ExpandLessIcon fontSize="small"/>}
    {!expanded && <ExpandMoreIcon fontSize="small"/>}
  </EnhancedIconButton>);
};

const TrainingArea = (props) => {
  const viewer = props.viewer as Viewer;
  const {trainingArea} = props;

  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);

  const clearTrainingArea = () => {
    // Delete all areas
    [...trainingArea.labels].forEach(label => {
      viewer?.deleteLabel(label.id);
    });

    setDeletePrompt(false);
  };

  const addThenExpand = () => {
    addLabel();
    setExpanded(true);
  };

  const addLabel = () => {
    viewer?.addTrainingAreaLabel();
  };

  const addNewLabelDisabled = viewer?.labelSelected();
  const addNewlabelTooltip = `
    Add new training area
    <br>Press space to add new
    <br>area to Training Areas
  `;

  return (
    <React.Fragment>
      <Card className={classes.card}>
        {/* Header */}
        <CardHeader
          className={classes.cardHeader}
          classes={{
            action: classes.cardButtons
          }}
          action={
            <React.Fragment>
              {/* Expand/collapse areas */}
              <CategoryExpand
                setExpanded={setExpanded}
                expanded={expanded}
              />

              {/* Add new area label */}
              <EnhancedIconButton
                title={addNewlabelTooltip}
                disabled={addNewLabelDisabled}
                onClick={() => {
                  addThenExpand();
                }}
              >
                <AddToPhotosIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Delete Training Area */}
              <EnhancedIconButton
                title="Clear All Training Areas"
                onClick={() => {
                  setDeletePrompt(true);
                }}
              >
                <DeleteIcon fontSize="small"/>
              </EnhancedIconButton>

            </React.Fragment>
          }
          disableTypography={true}
          title={
            <Typography
              variant="body2"
              className={classes.headerTitle}
            >
              Training Areas
            </Typography>
          }
          subheader={
            <Typography variant="caption">
              {`Total Areas: ${trainingArea.labels.length}`}
            </Typography>
          }
        />

        {/* Expandable content */}
        {expanded && (<CategoryContent
          viewer={viewer}
          category={trainingArea}
          labelName="Area"
          idx={0}
        />)}
      </Card>

      <PromptDialog
        open={deletePrompt}
        onCancel={() => setDeletePrompt(false)}
        onSubmit={clearTrainingArea}
        title="Clear Training Areas?"
        prompt={`Do you want to remove all Training Areas?`}
        button="Delete"
      />

    </React.Fragment>
  );
};

const Category = (props) => {
  const viewer = props.viewer as Viewer;
  const category = props.category as LabelCategory;

  const {isValidCategory, canRunTraining, runTextDetection,
    isSceneLabel} = props;

  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);
  const [editPrompt, setEditPrompt] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);
  const [sortPrompt, setSortPrompt] = useState(false);
  const [textDetectPrompt, setTextDetectPrompt] = useState(false);
  const [sorted, setSorted] = useState(false);

  const idx = viewer?.getIdxInList(category);


  const formatName = (name) => {
    const maxLength = 22;

    return (name.length > maxLength)
      ? name.substr(0, maxLength - 1) + "..."
      : name;
  };

  const addThenExpand = (categoryID) => {
    addLabel(categoryID);
    setExpanded(true);
  };

  const addLabel = (id) => {
    viewer?.addLabel(id);
  };

  const handleDeleteCategory = () => {
    viewer?.deleteCategory(category.id);
    setDeletePrompt(false);
  };

  const handleEditCategory = (name) => {
    if (!isValidCategory(name)) {
      return;
    }

    viewer?.editCategoryName(category.id, name);
    setEditPrompt(false);
  };

  const addNewLabelDisabled = viewer?.labelSelected();
  const addNewlabelTooltip = `
    Add new label
    <br>Press space to add new
    <br>label to ${viewer.currentCategory()} category
  `;

  const color = textToColor(category.name);

  const runSort = (scoreValue, sortType) => {
    viewer?.sortCategory(category, scoreValue, sortType);
    setSorted(true);
  };

  const undoSort = () => {
    viewer?.undoSort(category);
    setSorted(false);
  };

  const numLabelsTooltip = `Click to undo sort |
    Total labels pre-sort: ${category.numLabelsAll}`;

  useEffect(() => {
    if (idx >= 0) {
      setExpanded(true);
    }
  }, [idx]);

  return (
    <React.Fragment>
      <Card className={classes.card}>
        {/* Header */}
        <CardHeader
          className={classes.cardHeader}
          classes={{
            action: classes.cardButtons
          }}
          action={
            <React.Fragment>
              {/* Expand/collapse labels */}
              <CategoryExpand
                setExpanded={setExpanded}
                expanded={expanded}
              />

              {/* Detect Text in Class */}
              <EnhancedIconButton
                title="Detect Text in Category Labels"
                visible={isSceneLabel}
                onClick={() => {
                  if (!canRunTraining()) {
                    return;
                  }
                  setTextDetectPrompt(true);
                }}
              >
                <TextFieldsIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Sort by Scores */}
              <EnhancedIconButton
                title="Sort by Classification Score"
                onClick={() => {
                  setSortPrompt(true);
                }}
              >
                <SortIcon fontSize="small"/>
              </EnhancedIconButton>


              {/* Edit category name */}
              <EnhancedIconButton
                title="Edit Name"
                onClick={() => {
                  setEditPrompt(true);
                }}
              >
                <EditIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Add new label */}
              <EnhancedIconButton
                title={addNewlabelTooltip}
                disabled={addNewLabelDisabled}
                onClick={() => {
                  addThenExpand(category.id);
                }}
              >
                <AddToPhotosIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Delete category */}
              <EnhancedIconButton
                title="Delete class"
                onClick={() => {
                  setDeletePrompt(true);
                }}
              >
                <DeleteIcon fontSize="small"/>
              </EnhancedIconButton>

            </React.Fragment>
          }
          disableTypography={true}
          title={
            <Typography
              variant="body2"
              style={{color}}
              className={classes.headerTitle}
              title={category.name}
            >
              {formatName(category.name)}
            </Typography>
          }
          subheader={
            <React.Fragment>
              <Typography
                variant="caption"
              >
                {`Total Labels: ${category.labels.length}`}
              </Typography>
              {(sorted) && <ToolBarButton
                title={numLabelsTooltip}
                icon={"fa-undo"}
                onClick={() => undoSort()}
                error
              />}
            </React.Fragment>
          }
        />

        {/* Expandable content */}
        {expanded && (<CategoryContent
          viewer={viewer}
          category={category}
          labelName="Label"
          idx={idx}
          isSceneLabel={isSceneLabel}
        />)}

      </Card>

      <TextDialog
        open={editPrompt}
        onCancel={() => setEditPrompt(false)}
        onSubmit={handleEditCategory}
        title="Edit Class"
        prompt="Enter new class name"
        default={category.name}
        label="Class Name"
        clear={true}
      />

      <PromptDialog
        open={deletePrompt}
        onCancel={() => setDeletePrompt(false)}
        onSubmit={handleDeleteCategory}
        title="Delete Class?"
        prompt={`Do you want to delete this class (${category.name})? All labels will be removed`}
        button="Delete"
      />

      <ScoreSortingParameters
        open={sortPrompt}
        setOpen={setSortPrompt}
        category={category}
        runSort={runSort}
        defaultScore={'0.5'}
      />

      <TextDetectionParameters
        open={textDetectPrompt}
        setOpen={setTextDetectPrompt}
        category={category}
        runTextDetection={runTextDetection}
        viewer={viewer}
        defaultScore={'0.2'}
      />

    </React.Fragment>
  );
};

const LabelIntersectDialog = (props) => {
  const viewer = props.viewer as Viewer;
  const {open, setOpen, forceInitialProgress, setTrainClassifyExe,
    setTrainClassifyProgress, resetExecutableValues} = props;

  const classes = useStyles();

  const projectName = useSelector(selectName);
  const [method, setMethod] = useState("label_intersect");
  const [outputPath, setOutputPath] = useState(null);

  const defaults = {
    image_sampling_dist: {value: 1, error: false},
    intersection_angle: {value: 10, error: false},
    min_num_matches: {value: 2, error: false},
    position_confidence: {value: "high", error: false},
    max_distance_from_camera: {value: 60, error: false},
    close_label_dist: {value: 1, error: false},
    min_camera_distance: {value: 1, error: false},
    max_camera_distance: {value: 60, error: false},
    max_intersect_distance: {value: 1, error: false},
    cluster_distance: {value: 1, error: false},
    num_matches_required: {value: 3, error: false}
  };

  // Shared parameters
  const [imageSamplingDistance, setImageSamplingDistance] = useState(defaults.image_sampling_dist);

  // Point synthesis parameters
  const [intersectionAngle, setIntersectionAngle] = useState(defaults.intersection_angle);
  const [minNumMatches, setMinNumMatches] = useState(defaults.min_num_matches);
  const [positionConfidence, setPositionConfidence] = useState(defaults.position_confidence);
  const [maxDistanceFromCamera, setMaxDistanceFromCamera] = useState(defaults.max_distance_from_camera);
  const [closeLabelDist, setCloseLabelDist] = useState(defaults.close_label_dist);

  // Ray intersection parameters
  const [minCameraDistance, setMinCameraDistance] = useState(defaults.min_camera_distance);
  const [maxCameraDistance, setMaxCameraDistance] = useState(defaults.max_camera_distance);
  const [maxIntersectDistance, setMaxIntersectDistance] = useState(defaults.max_intersect_distance);
  const [clusterDistance, setClusterDistance] = useState(defaults.cluster_distance);
  const [numMatchesRequired, setNumMatchesRequired] = useState(defaults.num_matches_required);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    const jsonData = viewer?.labelObject();

    const noAnnotations = jsonData.annotations.length === 0;
    const noImages = jsonData.images.length === 0;
    if (noAnnotations || noImages) {
      toast.warning(`No exportable labels found. Active images are required`);
      return false;
    }

    // Write COCO file to temp path
    let text = JSON.stringify(jsonData, null, 2);
    let tempCocoPath = getTempFilePath("tempLabels.3dl");

    try {
      fs.writeFileSync(tempCocoPath, text, 'utf8');
    } catch(err) {
      console.log(err);
      toast.error(`Label export failed`);

      return;
    }

    // Export cameras to csv
    const csvEncompassPath = getTempFilePath('encompassTemp.csv');

    const written = await exportCamerasToCSV(
      viewer.activeImages(),
      csvEncompassPath
    );

    if (!written) {
      toast.error(`Writing to CSV failed`);

      return;
    }

    let exe = new PythonExecutable();

    // Shared parameters
    let commands = [
      "-p", method,
      "--csv_image_file", csvEncompassPath,
      "--coco_data_file", tempCocoPath,
      "--output_folder", outputPath,
      "--project_name", projectName,
      "--image_sampling_dist", imageSamplingDistance.value
    ];

    // Point synthesis parameters
    if (useFunctionV1) {
      commands = [
        ...commands,
        "--intersection_angle", intersectionAngle.value,
        "--min_num_matches", minNumMatches.value,
        "--position_confidence", positionConfidence.value,
        "--max_distance_from_camera", maxDistanceFromCamera.value,
        "--close_label_dist", closeLabelDist.value
      ];
    }

    // Ray intersection parameters
    if (useFunctionV2) {
      commands = [
        ...commands,
        "--min_camera_distance", minCameraDistance.value,
        "--max_camera_distance", maxCameraDistance.value,
        "--max_intersect_distance", maxIntersectDistance.value,
        "--cluster_distance", clusterDistance.value,
        "--num_matches_required", numMatchesRequired.value,
      ];
    }

    forceInitialProgress();
    setTrainClassifyExe(exe);

    toast.success(`Position export submitted...`);

    setOpen(false);

    exe.run({
      command: commands,
      saveLogs: true,
      onLine: jsonData => {
        if (!jsonData) {
          return;
        }

        if (jsonData.progress) {
          setTrainClassifyProgress(jsonData.progress);
        } else if (jsonData.positions_found) {
          toast.success(`Total positions exported: ${jsonData.positions_found}`);
        }
      },
      onClose: () => {
        try {
          toast.success(`Results saved to ${outputPath}`);
        }
        catch (err) {
          console.log(err);
          toast.error(`Failed to save results to ${outputPath}`);
        }
        finally {
          resetExecutableValues();
        }
      }
    });
  };

  const resetDefaultValues = () => {
    // Shared parameters
    setImageSamplingDistance(defaults.image_sampling_dist);

    // Point synthesis parameters
    setIntersectionAngle(defaults.intersection_angle);
    setMinNumMatches(defaults.min_num_matches);
    setPositionConfidence(defaults.position_confidence);
    setMaxDistanceFromCamera(defaults.max_distance_from_camera);
    setCloseLabelDist(defaults.close_label_dist);

    // Ray intersection parameters
    setMinCameraDistance(defaults.min_camera_distance);
    setMaxCameraDistance(defaults.max_camera_distance);
    setMaxIntersectDistance(defaults.max_intersect_distance);
    setClusterDistance(defaults.cluster_distance);
    setNumMatchesRequired(defaults.num_matches_required);
  };

  useEffect(() => {
    if (open) {
      return;
    }

    resetDefaultValues();
    setOutputPath(null);
  }, [open]);

  useEffect(() => {
    resetDefaultValues();
  }, [method]);

  const useFunctionV1 = method === "label_intersect";
  const useFunctionV2 = method === "label_intersect_v2";
  const folderSelected = outputPath !== null;

  let canSubmit = folderSelected
    && !imageSamplingDistance.error
    && !intersectionAngle.error
    && !minNumMatches.error
    && !positionConfidence.error
    && !maxDistanceFromCamera.error
    && !closeLabelDist.error
    && !minCameraDistance.error
    && !maxCameraDistance.error
    && !maxIntersectDistance.error
    && !clusterDistance.error
    && !numMatchesRequired.error;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={"sm"}
    >
      <DialogTitle>{"Label Analysis"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>

          {/* Export method */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Position Estimation Method</InputLabel>
            <Typography variant="caption">Determines which method will be used when estimating label positions. Each method comes with its own set of parameters</Typography>
            <Select
              value={method}
              fullWidth
              onChange={(event) => {
                let value = event.target.value as any;
                setMethod(value);
              }}
            >
              <MenuItem value={"label_intersect"}>Point Synthesization</MenuItem>
              <MenuItem value={"label_intersect_v2"}>Ray Intersection</MenuItem>
            </Select>
          </Grid>

          {/* Output folder */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <FolderWithLabel
              title={"Output Folder"}
              label={"The output folder where generated csvs will be created"}
              outputPath={outputPath}
              setOutputPath={setOutputPath}
            />
          </Grid>

        </Grid>

        <DenseDivider variant="middle" spacing={30}/>

        {/* Function parameters for V1 of function */}
        {useFunctionV1 && (<Grid container spacing={2}>

          {/* Minimum intersect angle */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Intersection Angle</InputLabel>
            <Typography variant="caption">The minimum allowed angle of intersection between two labels. Larger angles
              will create better geometry and more reliably estimates, but may exclude potential
              matches.</Typography>
            <NumberField
              data={intersectionAngle}
              setData={setIntersectionAngle}
              min={0}
              max={30}
              step={0.1}
            />
          </Grid>

          {/* Number of matches */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Minimum Number of Matches</InputLabel>
            <Typography variant="caption">The minimum number of matching label pairs. A smaller number will allow for
              more possible matches but with a greater possibility of false positives. A greater
              number will generate fewer matches but fewer false positives</Typography>
            <NumberField
              data={minNumMatches}
              setData={setMinNumMatches}
              min={1}
              max={50}
            />
          </Grid>

          {/* Position confidence */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Position Confidence</InputLabel>
            <Typography variant="caption">Confidence of output position. Higher confidence will mean labels with
              fewer corresponding matches will be removed.</Typography>
            <Select
              value={positionConfidence.value}
              onChange={(event) => {
                setPositionConfidence({
                  value: event.target.value as string,
                  error: false
                });
              }}
            >
              <MenuItem value={"low"}>Low</MenuItem>
              <MenuItem value={"medium"}>Medium</MenuItem>
              <MenuItem value={"high"}>High</MenuItem>
            </Select>
            <FormHelperText>{" "}</FormHelperText>
          </Grid>

          {/* Max camera distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Max Distance from Camera</InputLabel>
            <Typography variant="caption">Approximate maximum distance an object could be from the camera.</Typography>
            <NumberFieldWithUnits
              data={maxDistanceFromCamera}
              setData={setMaxDistanceFromCamera}
              min={1}
              max={100}
            />
          </Grid>

          {/* Image sampling distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Image Sampling Distance</InputLabel>
            <Typography variant="caption">Minimum distance between images. Any images closer than this will be ignored
              when estimating label positions.</Typography>
            <NumberFieldWithUnits
              data={imageSamplingDistance}
              setData={setImageSamplingDistance}
              min={0.2}
              max={5}
              step={0.1}
            />
          </Grid>

          {/* Clustering distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Duplicate Label Threshold</InputLabel>
            <Typography variant="caption">While estimating label positions, combine estimated positions that are
              within this distance of each other and part of the same category.</Typography>
            <NumberFieldWithUnits
              data={closeLabelDist}
              setData={setCloseLabelDist}
              min={0.2}
              max={5}
              step={0.1}
            />
          </Grid>
        </Grid>)}

        {/* Function parameters for V2 of function */}
        {useFunctionV2 && (<Grid container spacing={2}>

          {/* Intersect Distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Max Intersection Distance</InputLabel>
            <Typography variant="caption">The maximum allowed distance between
              calculated rays and the calculated intersection point.</Typography>
            <NumberFieldWithUnits
              data={maxIntersectDistance}
              setData={setMaxIntersectDistance}
              min={0.2}
              max={5}
              step={0.1}
            />
          </Grid>

          {/* Number of matches required */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Number of Required Matches</InputLabel>
            <Typography variant="caption">The number of label considered when
              calculating the best ray intersections. A smaller number will
              allow for more possible matches but with a greater possibility
              of false positives. A greater number will generate fewer matches
              but fewer false positives.</Typography>
            <NumberField
              data={numMatchesRequired}
              setData={setNumMatchesRequired}
              min={2}
              max={5}
            />
          </Grid>

          {/* Min camera distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Min Distance from Camera</InputLabel>
            <Typography variant="caption">Approximate minimum distance an object could be from the camera.</Typography>
            <NumberFieldWithUnits
              data={minCameraDistance}
              setData={setMinCameraDistance}
              min={0}
              max={20}
              step={0.5}
            />
          </Grid>

          {/* Max camera distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Max Distance from Camera</InputLabel>
            <Typography variant="caption">Approximate maximum distance an object could be from the camera.</Typography>
            <NumberFieldWithUnits
              data={maxCameraDistance}
              setData={setMaxCameraDistance}
              min={1}
              max={100}
            />
          </Grid>

          {/* Image sampling distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Image Sampling Distance</InputLabel>
            <Typography variant="caption">Minimum distance between images. Any images closer than this will be ignored
              when estimating label positions.</Typography>
            <NumberFieldWithUnits
              data={imageSamplingDistance}
              setData={setImageSamplingDistance}
              min={0.2}
              max={5}
              step={0.1}
            />
          </Grid>

          {/* Clustering distance */}
          <Grid item xs={6} className={classes.labelExportGrid}>
            <InputLabel>Duplicate Label Threshold</InputLabel>
            <Typography variant="caption">While estimating label positions, combine estimated positions that are
              within this distance of each other and part of the same category.</Typography>
            <NumberFieldWithUnits
              data={clusterDistance}
              setData={setClusterDistance}
              min={0.2}
              max={5}
              step={0.1}
            />
          </Grid>

        </Grid>)}

      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={!canSubmit} color="primary">
          Submit
        </Button>
      </DialogActions>

    </Dialog>
  );
};

const ImportDialog = (props) => {
  const classes = useStyles();

  const [disabled, setDisabled] = useState(false);
  const [importCategory, setImportCategory] = useState({});
  const [overwrite, setOverwrite] = useState(true);
  const [importLarge, setImportLarge] = useState(false);
  const [importPoints, setImportPoints] = useState(true);
  const [importLines, setImportLines] = useState(true);
  const [checkOverlap, setCheckOverlap] = useState(false);

  const [lineBuffer, setLineBuffer] = useState("0.5"); // TODO: pull from global setting later?
  const [pointBuffer, setPointBuffer] = useState("0.5"); // TODO: pull from global setting later?

  const viewer = props.viewer as Viewer;
  const {importData, setImportData, isOrthoLabel,
    categoryList, setLabelLoadProgress} = props;

  const open = importData !== null;
  const categories = importData ? importData.categories : [];
  let annotations = importData ? importData.annotations : [];

  const hasLines = annotations.filter(x => x.is_linestring).length > 0;
  const hasPoints = annotations.filter(x => x.is_point).length > 0;

  let hasLargeClasses = false;
  categories.forEach(category => {
    let numGeometry = annotations
      .filter(x => x.category_id === category.id)
      .length;
    if (numGeometry > geometryLimit) {
      hasLargeClasses = true;
    }
  });

  const columns = [
    {id: 'name', numeric: false, label: 'Class Name'},
    {id: 'count', numeric: true, label: 'Geometry Count'},
    {id: 'category', numeric: false, label: 'Imported Class Name'},
  ];

  const categoryNames = Array.from(new Set([
    ...categoryList.map(x => x.name),
    ...categories.map(x => x.name)
  ])).sort((a, b) => a.localeCompare(b));

  const filterAnnotationTypes = (data) => {
    return [...data].filter(x => {
      if (!importPoints && x.is_point) {
        return false;
      } else if (!importLines && x.is_linestring) {
        return false;
      }

      return true;
    });
  };

  const validBufferSize = (buffer) => {
    let bufferSize = parseFloat(buffer);
    let minIterations = 0.01;
    let maxIterations = 10;

    let validNumber = (bufferSize >= minIterations)
      && (bufferSize <= maxIterations);

    if (!validNumber) {
      toast.error(`Invalid buffer size. Must be between ${minIterations} - ${maxIterations}`);
      return false;
    }

    return true;
  };

  const handleClose = () => {
    setImportData(null);
  };

  const handleImport = async () => {
    if ((hasPoints && importPoints) && !validBufferSize(pointBuffer)) {
      return;
    }

    if ((hasLines && importLines) && !validBufferSize(lineBuffer)) {
      return;
    }

    const labelData = {
      ...importData,
      annotations: filterAnnotationTypes(importData.annotations)
    };

    const importCategories = [];

    labelData.categories.forEach((category, index) => {
      let newCategoryName = getMappedCategory(category.name);

      let numGeometry = labelData.annotations
        .filter(x => x.category_id === category.id)
        .length;

      if (numGeometry === 0) {
        return;
      }

      let ignoreLayer = (newCategoryName === LabelImportType.Ignore)
        || (importLarge ? false : numGeometry > geometryLimit);

      if (ignoreLayer) {
        // Filter our data for this category
        labelData.annotations = labelData.annotations
          .filter(x => x.category_id !== category.id);

        return;
      }

      importCategories.push({
        ...category,
        name: newCategoryName
      });
    });

    // Apply linestring / point buffer
    labelData.annotations.forEach((anno, index) => {
      if (anno.is_linestring) {
        labelData.annotations[index].buffer_size = lineBuffer;
      } else if (anno.is_point) {
        labelData.annotations[index].buffer_size = pointBuffer;
      }
    });

    // Replace categories with remapped version
    labelData.categories = importCategories;

    handleClose();

    // Nothing left, exit early
    if (labelData.categories.length === 0) {
      toast.warning(`No Labels Available To Load`);
    } else {
      await viewer.loadImageLabelData(
        labelData,
        setLabelLoadProgress,
        overwrite,
        checkOverlap
      );

      toast.success(`Labels Loaded Successfully...`);
    }
  };

  const getMappedCategory = (key) => {
    return importCategory[key]
      ? importCategory[key]
      : key;
  };

  const createSelect = (key, disabled) => {
    return (
      <Select
        disabled={disabled}
        disableUnderline
        value={getMappedCategory(key)}
        className={classes.tableDropdown}
        onChange={(event) => {
          const updated = {...importCategory};
          updated[key] = event.target.value;
          setImportCategory(updated);
        }}
      >
        {getLayerMenuItems()}
      </Select>
    );
  };

  const getLayerMenuItems = () => {
    const menuIgnore = (
      <MenuItem
        key={nanoid()}
        value={LabelImportType.Ignore}
      >
        Ignore Layer
      </MenuItem>
    );

    const menuDivider = (
      <hr key={nanoid()} className={classes.selectDivider}/>
    );

    return [
      menuIgnore,
      menuDivider,
      ...categoryNames.map(name => (
        <MenuItem
          key={nanoid()}
          value={name}
        >
          {name}
        </MenuItem>
      ))
    ];
  };

  const onMenuClick = (event) => {
    const value = event.target.value;
    const updated = {...importCategory};
    categories.forEach(data => {
      if (value === LabelImportType.Default) {
        delete updated[data.name];
      } else {
        updated[data.name] = value;
      }
    });

    setImportCategory(updated);
  };

  const handlePointBufferChange = (event) => {
    setPointBuffer(event.target.value);
  };

  const handleLineBufferChange = (event) => {
    setLineBuffer(event.target.value);
  };

  useEffect(() => {
    if (!importData) {
      setImportCategory({});
      setOverwrite(true);
      setCheckOverlap(false);
      setImportLarge(false);
      setImportPoints(true);
      setImportLines(true);
    }
  }, [importData]);

  useEffect(() => {
    let valid = true;

    if (importLines && lineBuffer === "") {
      valid = false;
    }

    if (importPoints && pointBuffer === "") {
      valid = false;
    }

    setDisabled(!valid);
  }, [importLines, importPoints, pointBuffer, lineBuffer]);

  annotations = filterAnnotationTypes(annotations);

  const rows = categories.map(data => {
    let numGeometry = annotations
      .filter(x => x.category_id === data.id)
      .length;

    let disabled = !importLarge && (numGeometry > geometryLimit);

    if (numGeometry === 0) {
      return null;
    }

    return {
      id: nanoid(),
      name: data.name,
      count: numGeometry,
      category: createSelect(data.name, disabled),
      disabled
    };
  }).filter(x => x !== null);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={"sm"}
    >
      <DialogTitle>Import Labels</DialogTitle>

      <Grid container spacing={0} className={classes.checkBoxParent}>

        {/* Setting layer default */}
        <Grid item xs={8}>
          <div className={clsx(classes.checkBoxWithLabel, classes.mappingMargin)}>
            <InputLabel>Apply Class Mapping</InputLabel>

            <Select
              disableUnderline
              value={"__empty"}
              onChange={onMenuClick}
            >
              <MenuItem disabled value="__empty">Select Option</MenuItem>
              <MenuItem value={LabelImportType.Default}>Default Mapping</MenuItem>
              {getLayerMenuItems()}
            </Select>
          </div>
        </Grid>

        {/* Overwrite existing labels */}
        <Grid item xs={8}>
          <div className={classes.checkBoxWithLabel}>
            <InputLabel>Overwrite Existing Labels</InputLabel>

            <Checkbox
              checked={overwrite}
              onChange={(event) => {
                setOverwrite(event.target.checked);
              }}
              size="small"
              color="secondary"
            />
          </div>
        </Grid>

        {/* Ignore outside image bounds */}
        {isOrthoLabel && (<Grid item xs={8}>
          <div className={classes.checkBoxWithLabel}>
            <InputLabel>Discard Non-Overlapping Labels</InputLabel>

            <ArrowTooltip title={`Discard labels that do not intersect with visible orthomosaics`}>
              <Checkbox
                checked={checkOverlap}
                onChange={(event) => {
                  setCheckOverlap(event.target.checked);
                }}
                size="small"
                color="secondary"
              />
            </ArrowTooltip>
          </div>
        </Grid>)}

        {/* Import large classes */}
        {hasLargeClasses && (<Grid item xs={8}>
          <div className={classes.checkBoxWithLabel}>
            <InputLabel>Import Large Classes</InputLabel>

            <ArrowTooltip title={`Import classes with ${geometryLimit}+ geometry count`}>
              <Checkbox
                checked={importLarge}
                onChange={(event) => {
                  setImportLarge(event.target.checked);
                }}
                size="small"
                color="secondary"
              />
            </ArrowTooltip>
          </div>
        </Grid>)}

        {/* Import polylines */}
        <Grid item xs={8}>
          {hasLines && (<div className={classes.checkBoxWithLabel}>
            <InputLabel>Import LineStrings</InputLabel>

            <Checkbox
              checked={importLines}
              onChange={(event) => {
                setImportLines(event.target.checked);
              }}
              size="small"
              color="secondary"
            />
          </div>)}
          {(hasLines && importLines) && (<Typography variant="caption">
            A buffer will be applied to convert to a polygon
          </Typography>)}
        </Grid>

        <Grid item xs={4}>
          {(hasLines && importLines) && (<div>
            <TextField
              margin="dense"
              type="number"
              fullWidth
              onChange={handleLineBufferChange}
              InputLabelProps={{ shrink: true }}
              label={`Line Buffer (${LocalScene.dataProjectionUnits})`}
              value={lineBuffer}
            />
          </div>)}
        </Grid>

        {/* Import points */}
        <Grid item xs={8}>
          {hasPoints && (<div className={classes.checkBoxWithLabel}>
            <InputLabel>Import Points</InputLabel>

            <Checkbox
              checked={importPoints}
              onChange={(event) => {
                setImportPoints(event.target.checked);
              }}
              size="small"
              color="secondary"
            />
          </div>)}
          {(hasPoints && importPoints) && (<Typography variant="caption">
            A buffer will be applied to convert to a polygon
          </Typography>)}
        </Grid>

        <Grid item xs={4}>
          {(hasPoints && importPoints) && (<div>
            <TextField
              margin="dense"
              type="number"
              fullWidth
              onChange={handlePointBufferChange}
              InputLabelProps={{ shrink: true }}
              label={`Point Buffer (${LocalScene.dataProjectionUnits})`}
              value={pointBuffer}
            />
          </div>)}
        </Grid>

      </Grid>

      <DialogContent className={classes.tablePadding}>
        <EnhancedTable
          dense
          deletable={false}
          columns={columns}
          rows={rows}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleImport} disabled={disabled}>Import Data</Button>
      </DialogActions>
    </Dialog>
  );
};


const AerialToLas = (props) => {
  const {categories, setClassifyLasPrompt, classifyLasPrompt, pointClouds, runAerialToLas,
    viewer} = props;

  const classes = useStyles();

  const LASfiles = pointClouds.filter(x => x.type === AssetType.LAS);
  const minLasVersion = Math.min(...LASfiles.map(pointCloud => {
    const header = viewer.getLasFileInfo(pointCloud.id);
    return header ? parseFloat(header.attributes.version) : 0;
  }));

  const visibleClouds = LASfiles.filter(x => x.visible);
  const mixedData = (LASfiles.length !== pointClouds.length);
  const maxNumClasses = (minLasVersion >= 1.4) ? 255 : 31;

  const [rows, setRows] = useState([]);
  const [sorted, setSorted] = useState(false);
  const [sortedAlpha, setSortedAlpha] = useState(false);
  const [sortByNum, setSortByNum] = useState(false);
  const [overwriteFiles, setOverwriteFiles] = useState(false);
  const [preserveGround, setPreserveGround] = useState(false);
  const [newLasPath, setNewLasPath] = useState(null);

  const canSubmit = (visibleClouds.length > 0)
    && (minLasVersion > 0)
    && ((newLasPath !== null) || (overwriteFiles))
    && rows.filter(x => x.error).length === 0;

  const checkNamesForClass = (name) => {
    let classNum = getClassFromAlias(name);
    if (classNum < 0) {
      classNum = 0;
    }
    return classNum;
  };

  const getRows = (categories) => {
    let rowsTemp = categories.map((category, index) => {
      let name = category.name;
      let lasClass = checkNamesForClass(name);

      return {
        id: index.toString(),
        index: index,
        primary: name,
        secondary: lasClass,
        error: false,
        min: 0,
        max: maxNumClasses,
        step:1,
      };
    });

    setRows([...rowsTemp]);
  };

  const updateClassNumbers = (data) => {
    let rowsTemp = [...rows];
    rowsTemp[data.index].secondary = data.value;
    rowsTemp[data.index].error = data.error;
    setRows([...rowsTemp]);
  };

  const handleCancel = () => {
    setClassifyLasPrompt(false);
  };

  const handleSubmit = () => {
    const applicationOrder = rows.map(row => {
      return row.primary;
    });
    const lasClasses = rows.map(row => {
      return row.secondary;
    });
    const pointCloudPaths = visibleClouds.map(pointCloud => {return pointCloud.data.path;});
    setClassifyLasPrompt(false);
    runAerialToLas(applicationOrder, lasClasses, newLasPath, pointCloudPaths,
      !preserveGround, overwriteFiles, visibleClouds);
  };

  const sortRowsByClassNum = (reverseSort) => {
    let rowsTemp = [...rows];
    if (rows.length === 0) {
      return;
    }

    if (!reverseSort){
      rowsTemp.sort((a,b) => a.secondary - b.secondary);
    }
    else {
      rowsTemp.sort((a,b) => b.secondary - a.secondary);
    }

    rowsTemp.forEach((row, index) => row.index=index);
    setRows([...rowsTemp]);
    setSortByNum(!reverseSort);
    setSorted(true);
  };

  const sortRowsAlphabetically = () => {
    let rowsTemp = [...rows];
    if (rows.length === 0) {
      return;
    }

    rowsTemp.sort((a, b) => a.primary.localeCompare(b.primary));
    rowsTemp.forEach((row, index) => row.index=index);
    setSortedAlpha(true);
    setRows([...rowsTemp]);
  };

  const sortReset = () => {
    let rowsTemp = [...rows];
    if (rows.length === 0) {
      return;
    }

    rowsTemp.sort((a,b) => parseInt(a.id) - parseInt(b.id));
    rowsTemp.forEach((row, index) => row.index=index);
    setSorted(false);
    setSortedAlpha(false);
    setRows([...rowsTemp]);
  };

  const sortButtonTitle = () => {
    if (sorted) {
      return "Reverse Sort Order";
    }
    return "Sort by Las Classification";
  };

  const onDragEnd = ({ destination, source }: DropResult) => {
    if (!destination) return;

    let rowsTemp = [...rows];
    const [removed] = rowsTemp.splice(source.index, 1);
    rowsTemp.splice(destination.index, 0, removed);
    rowsTemp.forEach((row, index) => row.index=index);

    setRows([...rowsTemp]);
    return;
  };

  useEffect(() => {
    getRows(categories);
  }, [classifyLasPrompt]);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={classifyLasPrompt}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle className={classes.paddingTop}>{"Classify Point Cloud from Aerial Image"}</DialogTitle>
      <DialogContent className={classes.captionPadding}>
        <Typography variant="caption">
          Classes lower in the list will be applied last, and thus be
          prioritized in the case of overlapping label areas
        </Typography>

        <div className={classes.paddingBottomAndTopMinimal}>
          <EnhancedIconButton
            title={sortButtonTitle()}
            onClick={() => {
              sortRowsByClassNum(sortByNum);
            }}
          >
            <ImportExportIcon fontSize="small"/>
          </EnhancedIconButton>

          <EnhancedIconButton
            title="Sort by Class Name"
            onClick={() => {
              sortRowsAlphabetically();
            }}
          >
            <SortByAlphaIcon fontSize="small"/>
          </EnhancedIconButton>


          {(sorted || sortedAlpha) && <EnhancedIconButton
            title="Reset to Original Order"
            onClick={() => {
              sortReset();
            }}
          >
            <HistoryIcon fontSize="small"/>
          </EnhancedIconButton>}
        </div>

        <Paper className={classes.flexPaper}>
          <DraggableList
            items={rows}
            onDragEnd={onDragEnd}
            setData={updateClassNumbers}
            inputName='LAS Classification'
          />
        </Paper>

        <Grid container spacing={2}>

          {/* Preserve ground classification */}
          <Grid item xs={12}>
            <div className={classes.checkBoxWithLabel}>
              <InputLabel>Preserve Ground</InputLabel>
              <ArrowTooltip
                title="Points in Point Cloud pre-classified as ground won't be reclassified"
              >
                <Checkbox
                  checked={preserveGround}
                  onChange={(event) => {
                    setPreserveGround(event.target.checked);
                  }}
                  classes={{root: classes.toggleOptionCheckbox}}
                  size="small"
                  color="secondary"
                />
              </ArrowTooltip>
            </div>
          </Grid>

          {/* Overwrite point clouds */}
          <Grid item xs={12}>
            <div className={classes.checkBoxWithLabel}>
              <InputLabel>Overwrite Existing LAS files</InputLabel>
              <ArrowTooltip
                title="Las files will be overwritten, rather than reclassified copies being added to an output folder."
              >
                <Checkbox
                  checked={overwriteFiles}
                  onChange={(event) => {
                    setOverwriteFiles(event.target.checked);
                  }}
                  classes={{root: classes.toggleOptionCheckbox}}
                  size="small"
                  color="secondary"
                />
              </ArrowTooltip>
            </div>
          </Grid>

          {/* Output folder */}
          {!overwriteFiles && <Grid item xs={12}>
            <FolderWithLabel
              title={"Point Cloud Path"}
              label={"Output Las File Destination of New Classified Files"}
              outputPath={newLasPath}
              setOutputPath={setNewLasPath}
              defaultPath={viewer?.projectName}
            />
          </Grid>}

        </Grid>

        {mixedData && (<Box className={classes.mixedDataWarning}>
          <Typography variant="caption" align="center">
            Classification from Aerial will only apply to LAS files.
          </Typography>
        </Box>)}

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={!canSubmit}
        >
          Submit
        </Button>
      </DialogActions>

    </Dialog>
  );
};

const ClassificationParameters = (props) => {
  const {open, setOpen, runClassification, defaultScore} = props;

  const classes = useStyles();
  const [modelPath, setModelPath] = useState(null);
  const [runOnCPU, setRunOnCPU] = useState(false);
  const [score, setScore] = useState({
    value: defaultScore,
    error: false
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    toast.success(`Image classification submitted...`);

    runClassification(parseFloat(score.value), modelPath, runOnCPU);
    setOpen(false);
  };

  const resetDefaults = () => {
    setModelPath(null);
    setRunOnCPU(false);
    setScore({value: defaultScore, error: false});
  };

  useEffect(() => {
    if (open) {
      return;
    }

    resetDefaults();
  }, [open]);

  const canSubmit = (modelPath !== null) && (!score.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{"Model Classification Parameters"}</DialogTitle>

      <DialogContent>

        {/* Classification Score */}
        <InputLabel>Classification Score</InputLabel>
        <NumberField
          className={classes.paddingBottom}
          data={score}
          setData={setScore}
          min={0.1}
          max={1.0}
          step={0.1}
        />

        {/* Model path */}
        <div className={classes.paddingBottom}>
          <FileWithLabel
            title={"Model File"}
            label={"Trained model file that is used to classify images."}
            filter={modelFilter}
            filePath={modelPath}
            setFilePath={setModelPath}
          />
        </div>

        {/* Run on CPU */}
        <div className={classes.checkBoxWithLabel}>
          <InputLabel>Run On CPU</InputLabel>
          <Checkbox
            checked={runOnCPU}
            onChange={(event) => {
              setRunOnCPU(event.target.checked);
            }}
            size="small"
            color="secondary"
          />
        </div>

        <Typography variant="caption" className={classes.paddingBottom}>
          Running on CPU is slower, but may be nessecary if your GPU is not compatible
        </Typography>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const TrainingParameters = (props) => {
  const {open, setOpen, runTraining, defaultIterations} = props;

  const classes = useStyles();
  const [outputPath, setOutputPath] = useState(null);
  const [pretrainedPath, setPretrainedPath] = useState(null);
  const [runOnCPU, setRunOnCPU] = useState(false);
  const [iterations, setIterations] = useState({
    value: defaultIterations,
    error: false,
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    toast.success(`Image training submitted...`);

    runTraining(parseInt(iterations.value), outputPath, pretrainedPath, runOnCPU);
    setOpen(false);
  };

  const resetDefaults = () => {
    setPretrainedPath(null);
    setRunOnCPU(false);
    setOutputPath(null);
    setIterations({value: defaultIterations, error: false});
  };

  useEffect(() => {
    if (open) {
      return;
    }

    resetDefaults();
  }, [open]);

  const canSubmit = (outputPath !== null) && (!iterations.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{"Model Training Parameters"}</DialogTitle>

      <DialogContent>

        {/* Training iterations */}
        <InputLabel>Training Iterations</InputLabel>
        <NumberField
          className={classes.paddingBottom}
          data={iterations}
          setData={setIterations}
          min={10}
          max={8192}
        />

        {/* Output folder */}
        <div className={classes.outputFolder}>
          <FolderWithLabel
            title={"Model Output Folder"}
            label={"The output folder where the new model will be created"}
            outputPath={outputPath}
            setOutputPath={setOutputPath}
          />
        </div>

        {/* Run on CPU */}
        <div className={classes.checkBoxWithLabel}>
          <InputLabel>Run On CPU</InputLabel>
          <Checkbox
            checked={runOnCPU}
            onChange={(event) => {
              setRunOnCPU(event.target.checked);
            }}
            size="small"
            color="secondary"
          />
        </div>

        <Typography variant="caption" className={classes.paddingBottom}>
          Running on CPU is slower, but may be nessecary if your GPU is not compatible
        </Typography>

        {/* Pretrained model */}
        <FileWithLabel
          title={"Pretrained Model Path (Optional)"}
          label={`If a previously trained model is selected, the number of classes in
            the new and old classes must match exactly.`}
          filter={modelFilter}
          filePath={pretrainedPath}
          setFilePath={setPretrainedPath}
          optional
        />

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const GetInfoWindow = (props) => {
  const {open, setOpen, label, index, viewer, isSceneLabel} = props;
  const orignalText = label.text.split('\n');
  const classes = useStyles();

  const [text, setText] = useState(orignalText);

  const scoreClass = (score) => {
    let scoreValidity = classes.success;
    if (score < 0.9) {
      scoreValidity = classes.warning;
    }
    if (score < 0.7) {
      scoreValidity = classes.error;
    }
    return scoreValidity;
  };

  const handleCancel = () => {
    setText([...orignalText]);
    setOpen(false);
  };

  const updateLabelText = (txtList) => {
    const newText = txtList.join("\n");
    viewer?.setLabelText(label.id, newText);
  };

  const handleSubmit = () => {
    let trimmedText = text.map(x => x.trim());
    setText([...trimmedText]);
    updateLabelText(trimmedText);
    setOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleTextChange = (event, index) => {
    let newText = [...text];
    newText[index] = event.target.value;
    setText([...newText]);
  };

  const classValid = label.valid ? classes.success : classes.error;
  const classHighlight = label.highlighted ? classes.success : classes.error;

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{`Label Info`}</DialogTitle>

      <DialogContent>
        <InputLabel>Information</InputLabel>
        <List>

          {/** Label Number */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {`Label #${index}`}
            </Typography>
          </ListItem>

          {/** Valid Geometry */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {"Polygon Valid:"}
            </Typography>
            <Typography variant="caption" className={classValid}>
              {String(label.valid).toUpperCase()}
            </Typography>
          </ListItem>

          {/** Highlighted */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {"Highlighted:"}
            </Typography>
            <Typography variant="caption" className={classHighlight}>
              {String(label.highlighted).toUpperCase()}
            </Typography>
          </ListItem>

          {/** Classification Score */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {"Classification Score:"}
            </Typography>
            <Typography variant="caption" className={scoreClass(label.score)}>
              {label.score.toFixed(2)}
            </Typography>
          </ListItem>

          {(isSceneLabel) && <React.Fragment>
            {/** Text Confidence */}
            <ListItem>
              <Typography variant="caption" className={classes.infoLabel}>
                {"Text Detection Score:"}
              </Typography>
              <Typography variant="caption" className={scoreClass(label.textScore)}>
                {`${label.textScore.toFixed(2)}`}
              </Typography>
            </ListItem>

            {/** Detected Text */}
            <ListItem>
              <List>
                {text.map((txt, index)=>
                  <TextField
                    key={index}
                    onChange={(event) => handleTextChange(event, index)}
                    onKeyDown={(event) => handleKeyDown(event)}
                    autoFocus
                    margin="dense"
                    size="small"
                    label={`Detected Text Line ${index+1}`}
                    type="text"
                    fullWidth
                    value={txt}
                  />
                )}
              </List>
            </ListItem>

          </React.Fragment>}

        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Close
        </Button>
        {(isSceneLabel) && <Button onClick={handleSubmit} color="primary">
          Save
        </Button>}
      </DialogActions>
    </Dialog>
  );
};

const TextDetectionParameters = (props) => {
  const {open, setOpen, runTextDetection, defaultScore,
    category, viewer} = props;

  const classes = useStyles();
  const [spellcheck, setSpellcheck] = useState(false);
  const [score, setScore] = useState({
    value: defaultScore,
    error: false
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    viewer?.setLabelFindText(category.id);
    runTextDetection(parseFloat(score.value), spellcheck);
    setOpen(false);
  };

  const resetDefaults = () => {
    setSpellcheck(false);
    setScore({value: defaultScore, error: false});
  };

  useEffect(() => {
    if (open) {
      return;
    }

    resetDefaults();
  }, [open]);

  const canSubmit = (!score.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{`Detect Text in ${category.name} Labels`}</DialogTitle>

      <DialogContent>

        {/* Classification Score */}
        <InputLabel>Detection Score Threshold</InputLabel>
        <Typography variant="caption">
          {`Detected text with detection scores below this value will not be added to labels`}
        </Typography>
        <NumberField
          className={classes.paddingBottom}
          data={score}
          setData={setScore}
          min={0.1}
          max={1.0}
          step={0.1}
        />

        {/* Spell check toggle */}
        <div className={classes.checkBoxWithLabel}>
          <InputLabel>Spell Check Detected Text</InputLabel>
          <Checkbox
            checked={spellcheck}
            onChange={(event) => {
              setSpellcheck(event.target.checked);
            }}
            size="small"
            color="secondary"
          />
        </div>

        <Typography variant="caption">
          {`Utilize spell checking to correct spelling mistakes cause by imperfect detection.`}
        </Typography>


      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ScoreSortingParameters = (props) => {
  const {open, setOpen, runSort, defaultScore, category} = props;

  const classes = useStyles();
  const [sortType, setSortType] = useState('descending');
  const [score, setScore] = useState({
    value: defaultScore,
    error: false
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    toast.success(`Sorting Labels by classification...`);

    runSort(parseFloat(score.value), sortType);
    setOpen(false);
  };

  /*
  useEffect(() => {
    if (open) {
      return;
    }

    // Reset default values
    setSortType('descending');
    setScore({value: defaultScore, error: false});
  }, [open]);
  */

  const canSubmit = (!score.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{`Sort ${category.name} Labels`}</DialogTitle>

      <DialogContent>

        {/* Classification Score */}
        <InputLabel>Classification Score Threshold</InputLabel>
        <Typography variant="caption">
          {`Labels with classification scores below this value will be removed from ${category.name}`}
        </Typography>
        <NumberField
          className={classes.paddingBottom}
          data={score}
          setData={setScore}
          min={0.1}
          max={1.0}
          step={0.1}
        />

        {/* Sort Type */}
        <div>
          <InputLabel>Sorting Method</InputLabel>
          <Typography variant="caption">
            Choose method, if any, by which to sort the category.
          </Typography>

          <div>
            <Select
              value={sortType}
              fullWidth
              onChange={(event) =>{
                let value = event.target.value as any;
                setSortType(value);
              }}
            >
              <MenuItem value={"ascending"}>Ascending (low to high)</MenuItem>
              <MenuItem value={"descending"}>Descending (high to low)</MenuItem>
              <MenuItem value={"none"}>Don't Sort</MenuItem>
            </Select>
            <FormHelperText>{" "}</FormHelperText>
          </div>
        </div>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ImageLabelling = (props) => {
  const viewer = props.viewer as Viewer;
  const {setDefaultTab, setTabsEnabled, categoryList, trainingArea,
    imageLabelOpen, setImageLabelOpen} = props;

  const classes = useStyles();
  const dispatch = useDispatch();

  const [labelType, setLabelType] = useState(null);
  const [minimized, setMinimized] = useState(null);
  const [addCategory, setAddCategory] = useState(false);
  const [classifyLasPrompt, setClassifyLasPrompt] = useState(false);
  const [closePrompt, setClosePrompt] = useState(false);
  const [importData, setImportData] = useState(null);
  const [modalName, setModalName] = useState("");
  const [labelLoadProgress, setLabelLoadProgress] = useState(0);
  const [trainClassifyProgress, updateTrainClassifyProgress] = useState(0);
  const [trainClassifyExe, setTrainClassifyExe] = useState(null);
  const [processType, setProcessType] = useState("");
  const [classification, setClassification] = useState(false);
  const [readingLabelFile, setReadingLabelFile] = useState(false);
  const [training, setTraining] = useState(false);
  const [trainingURL, setTrainingURL] = useState(null);
  const [downloadingResources, setDownloadingResources] = useState("");
  const [downloadResourcesDialog, setDownloadResourcesDialog] = useState("");
  const [trainingPrompt, setTrainingPrompt] = useState(false);
  const [classificationPrompt, setClassificationPrompt] = useState(false);
  const [labelExportOpen, setLabelExportOpen] = useState(false);
  const [textDetection, setTextDetection] = useState(false);
  const [classifyingFromAerial, setClassifiyingFromAerial] = useState(false);
  const [potentialIssue, setPotentialIssue] = useState(null);
  const assets = useSelector(selectAllAssets);
  const cameraFiles = getCameraFileAssets(assets);
  const pointCloudFiles = getPointCloudAssets(assets);
  const defaultFolder = useSelector(selectDefaultFolder);

  const isOrthoLabel = labelType === "ortho";
  const isSceneLabel = labelType === "scene";
  const numPanoramics = cameraFiles.filter(x => x.type === AssetType.Panoramic).length;
  const numPlanars = cameraFiles.filter(x => x.type === AssetType.Planar).length;
  const canExportCSV = isSceneLabel && (numPlanars === 0);

  // UI progress needs to be throttled, so it doesnt update too quickly and freeze the app
  const progressThrottleMilliseconds = 50;
  const setTrainClassifyProgress = useCallback(throttle(
    progressThrottleMilliseconds, (value) => {
      updateTrainClassifyProgress(value);
    }), []);

  const resetExecutableValues = () => {
    setTrainClassifyProgress(0);
    setTrainingURL(null);
    setDownloadingResources("");
    setTraining(false);
    setClassification(false);
    setTextDetection(false);
    setClassifiyingFromAerial(false);
  };

  const handleOpen = (type) => {
    setImageLabelOpen(true);
    setLabelType(type);
  };

  const handleClose = () => {
    setImageLabelOpen(false);
    handleCancelProgress();
  };

  const handleMinimize = () => {
    setMinimized(true);
  };

  const checkClose = () => {
    if (isModified) {
      setClosePrompt(true);
    } else {
      handleClose();
    }
  };

  const isValidCategory = (name) => {
    // Uniqueness check
    const isUnique = viewer?.checkCategoryUniqueness(name);
    if (!isUnique) {
      toast.error(`Class already exists`);
      return false;
    }

    return true;
  };

  const handleCategoryChange = (state) => {
    setAddCategory(state);
  };

  const classifyLas = (state) => {
    setClassifyLasPrompt(state);
  };

  const handleCancel = () => {
    handleCategoryChange(false);
  };

  const handleAddCategory = (name) => {
    if (!isValidCategory(name)) {
      return;
    }

    viewer?.addCategory(name);
    handleCategoryChange(false);
  };

  const handleCancelProgress = () => {
    trainClassifyExe?.destroy();
    resetExecutableValues();
  };

  const handleViewTraining = (url) => {
    ipcRenderer?.send("show-training-window", url);
  };

  const exportImageLabels = () => {
    // No labels to export
    if (categoryList.length === 0) {
      toast.warning(`No labels created to export`);
      return;
    }

    dialog.showSaveDialog({
      defaultPath: viewer.projectName,
      filters: [
        ...labelFilter,
        ...(isOrthoLabel ? dxfFilter : []),
        ...(isOrthoLabel ? shpFilter : [])
      ],
    }).then(result => {
      if (result.canceled) {
        return;
      }

      if (result.filePath) {
        const filePath = slash(result.filePath);
        const extension = path.extname(filePath);

        if (extension === ".dxf") {
          exportToLinework(filePath, extension, "dxf_path");
        }

        if (extension === ".shp") {
          exportToLinework(filePath, extension, "shp_path");
        }

        if (extension === ".3dl") {
          exportLabels3DL(filePath);
        }
      }
    }).catch(error => {
      console.log(error);
    });
  };

  /** @private */
  const exportLabels3DL = (filePath) => {
    let json = viewer?.labelObject();
    let text = JSON.stringify(json, null, 2);
    fs.writeFile(filePath, text, 'utf8', (err) => {
      if (err) {
        console.log(err);
        toast.error(`Failed to export labels`);
      }
      else {
        toast.success(`Image labels saved to ${path.basename(filePath)}`);
        console.log(`File written successfully to ${filePath}`);
      }
    });
  };

  /** @private */
  const exportToLinework = (filePath, extension, outputKey) => {
    const jsonData = viewer?.labelObject();

    const noAnnotations = jsonData.annotations.length === 0;
    const noImages = jsonData.images.length === 0;
    if (noAnnotations || noImages) {
      toast.warning(`No exportable labels found. Active images are required`);
      return false;
    }

    // Write COCO file to temp path
    let text = JSON.stringify(jsonData, null, 2);
    let tempCocoPath = getTempFilePath("tempLabels.3dl");

    try {
      fs.writeFileSync(tempCocoPath, text, 'utf8');
    } catch(err) {
      console.log(err);
      toast.error(`Label export failed`);

      return;
    }

    let pythonName;
    if (extension === ".dxf") {
      pythonName = "coco_to_dxf";
    } else if (extension === ".shp") {
      pythonName = "coco_to_shp";
    }

    if (!pythonName) {
      return;
    }

    let exe = new PythonExecutable();
    let commands = [
      "-p", pythonName,
      "--coco_path", tempCocoPath,
      `--${outputKey}`, filePath
    ];

    exe.run({
      command: commands,
      saveLogs: true,
      onClose: () => {
        try {
          toast.success(`File saved to ${path.basename(filePath)}`);
        }
        catch (err) {
          console.log(err);
          toast.error(`Failed to save file to ${extension}`);
        }
      }
    });
  };

  const importImageLabels = () => {
    const combinedExtensions = getCombinedExtension(
      "Supported Files", [
        labelFilter,
        modelFilter,
        isOrthoLabel ? drawingFilter : null
      ]);

    dialog.showOpenDialog({
      properties: ['openFile'],
      filters: [
        combinedExtensions,
        ...labelFilter,
        ...modelFilter,
        ...(isOrthoLabel ? drawingFilter : [])
      ]
    }).then(result => {
      if (result.canceled) {
        return;
      }

      const filePath = slash(result.filePaths[0]);
      const extension = path.extname(filePath);

      if (extension === ".pth") {
        importLabelsPTH(filePath);
      }

      if (extension === ".3dl") {
        importLabels3DL(filePath);
      }

      const  importLinework =
        (extension === ".shp")
        || (extension === ".dxf")
        || (extension === ".zip");

      if (importLinework) {
        importLabelsLinework(filePath);
      }
    }).catch(error => {
      setReadingLabelFile(false);
      console.log(error);
    });
  };

  /** @private */
  const importLabelsPTH = (filePath) => {
    setReadingLabelFile(true);

    const exe = new PythonExecutable();

    let response;
    let commands = [
      "-p", "extract_coco_from_model",
      "--model_path", filePath,
    ];

    exe.run({
      command: commands,
      saveLogs: true,
      onLine: jsonData => {
        if (jsonData.downloading_resources) {
          setDownloadResourcesDialog("download");
        } else if (jsonData.extracting_resources) {
          setDownloadResourcesDialog("extract");
        } else if (jsonData.coco_data) {
          response = jsonData.coco_data;
        }
      },
      onClose: () => {
        setDownloadResourcesDialog("");

        if (response) {
          importLabelData(response);
        } else {
          toast.error(`Error reading image labels file`);
        }
      }
    });
  };

  /** @private */
  const importLabelsLinework = (filePath) => {
    setReadingLabelFile(true);

    const exe = new PythonExecutable();

    let response;
    let commands = [
      "-p", "convert_linework",
      "--input_paths", [filePath],
    ];

    exe.run({
      command: commands,
      onLine: jsonData => {
        if (jsonData.label_data) {
          response = {
            ...jsonData.label_data,
            projection: LocalScene.dataProjection
          };
        }
      },
      onClose: () => {
        importLabelData(response);
      }
    });
  };

  /** @private */
  const importLabels3DL = (filePath) => {
    try {
      const text = fs.readFileSync(filePath, 'utf8');
      const data = JSON.parse(text);
      importLabelData(data);
    } catch {
      toast.error(`Error reading image labels file`);
    }
  };

  /** @private */
  const importLabelData = (data) => {
    setReadingLabelFile(false);

    if (!data) {
      toast.error(`Error reading image labels file`);
      return;
    }

    if (data.type !== labelType) {
      toast.error(`Label type mismatch: "${data.type}"`);
      return;
    }

    setImportData(data);
  };

  const forceInitialProgress = () => {
    setTrainClassifyProgress(0.001);
  };

  const cudaErrorDialog = (cudaError) => {
    dialog.showMessageBox({
      title: 'Cuda Error',
      message: `${cudaError} version of Cuda found. This is not the correct version to run this functionality. Select 'Get Cuda' to download and install the correct version.`,
      buttons: ['Dismiss', 'Get Cuda'],
      type: 'error',
      noLink: true
    }).then(selection => {
      if (selection.response === 1) {
        shell.openExternal('https://developer.nvidia.com/cuda-11.1.0-download-archive?target_os=Windows&target_arch=x86_64&target_version=10');
      }
    });
  };

  const updateDownloadingResources = (jsonData) => {
    if (jsonData.downloading_resources) {
      setDownloadingResources("download");
    } else if (jsonData.extracting_resources) {
      setDownloadingResources("extract");
    } else {
      setDownloadingResources("");
    }
  };

  const canRunClassification = () => {
    const imagePaths = viewer.loadedImageLabelPaths();
    if (imagePaths.length === 0) {
      toast.warning(`No images found for classification`);
      return false;
    }

    return true;
  };

  const runClassification = (score, modelPath, runOnCPU) => {
    if (training || textDetection) {
      toast.warning(`Cannot run Classification until training is complete`);
      return;
    }

    resetExecutableValues();
    setClassification(true);

    let tempImagePath = getTempFilePath("imagePathsTmp.txt");
    let imageData = viewer.loadedImageLabelPaths();
    let imageJSON = JSON.stringify(imageData, null, 4);

    try {
      fs.writeFileSync(tempImagePath, imageJSON, 'utf8');
    } catch(err) {
      console.log(err);
      toast.error(`Error running classification`);

      setTraining(false);
      return;
    }

    try {
      let pythonName = isOrthoLabel
        ? "image_classification_orthomosaic"
        : "image_classification_panoramic";

      let commands = [
        "-p", pythonName,
        "--image_paths_txt", tempImagePath,
        "--output_folder", tempDirectoryPath,
        "--prediction_model", modelPath,
        "--proj_string", LocalScene.dataProjection,
        "--prediction_score_threshold", score,
        "--run_on_cpu", runOnCPU
      ];

      forceInitialProgress();

      let importData;
      let exe = new PythonExecutable();
      setTrainClassifyExe(exe);

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          updateDownloadingResources(jsonData);

          if (jsonData.cudaError){
            cudaErrorDialog(jsonData.cudaError);
          }

          if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.coco_data) {
            importData = jsonData.coco_data;
          }
        },
        onClose: async () => {
          try {
            if (importData) {
              toast.success(`Classification complete, loading detected labels...`);

              await viewer.loadImageLabelData(
                importData,
                setLabelLoadProgress,
                true, // overwrite existing labels
                false // dont check for label overlap
              );
              toast.success(`Labels Loaded Successfully...`);
            } else {
              toast.error(`Error running classification`);
            }
          }
          catch (err) {
            toast.error(`Error running classification`);
          }
          finally {
            resetExecutableValues();
          }
        }
      });
    } catch {
      setClassification(false);
      toast.error(`Error running classification`);
    }
  };

  const canRunTraining = () => {
    let jsonData = viewer?.labelObject();
    const noAnnotations = jsonData.annotations.length === 0;
    const noImages = jsonData.images.length === 0;
    if (noAnnotations || noImages) {
      toast.warning(`No training labels found. Active images are required`);
      return false;
    }

    return true;
  };

  const runTraining = (numIterations, outputPath, pretrainedModelPath, runOnCPU) => {
    if (training || textDetection) {
      toast.warning(`Cannot run training last process complete is complete`);
      return;
    }

    resetExecutableValues();
    setTraining(true);

    let modelPath;
    let tempCocoPath = path.join(outputPath, "labels_for_training.3dl");
    let tempImagePath = getTempFilePath("imagePathsTmp.txt");

    try {
      let jsonData = viewer?.labelObject();
      let imageData = viewer.activeImageLabelPaths();

      let labelJSON = JSON.stringify(jsonData, null, 4);
      let imageJSON = JSON.stringify(imageData, null, 4);

      try {
        fs.writeFileSync(tempImagePath, imageJSON, 'utf8');
        fs.writeFileSync(tempCocoPath, labelJSON, 'utf8');
      } catch(err) {
        console.log(err);
        toast.error(`Failed to export labels for training`);

        setTraining(false);
        return;
      }

      // TODO: use specific training / classification python name

      forceInitialProgress();

      let pythonName = isOrthoLabel
        ? "image_training_orthomosaic"
        : "image_training_panoramic";

      let exe = new PythonExecutable();
      let commands = [
        "-p", pythonName,
        "--image_paths_txt", tempImagePath,
        "--output_folder", outputPath,
        "--coco_data_file", tempCocoPath,
        "--solver_max_iterations", numIterations,
        "--batch_size_per_image", 256,
        "--run_on_cpu", runOnCPU
      ];

      setTrainClassifyExe(exe);

      if (pretrainedModelPath) {
        commands = [
          ...commands,
          "--pretrained_model_pth",
          pretrainedModelPath
        ];
      }

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          updateDownloadingResources(jsonData);
          if (jsonData.cudaError){
            cudaErrorDialog(jsonData.cudaError);
          }

          else if (jsonData.gpu_memory_error) {
            toast.warning(`GPU has insufficient memory. Switching to CPU based training`);
          } else if (jsonData.model_diverge_error){
            toast.error(`Training model has diverged, training data may be insufficient or inaccurate`);
          } else if (jsonData.label_bounds_error){
            toast.error("Unable to find any labels inside the defined image bounds");
          } else if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.model_file_path) {
            modelPath = jsonData.model_file_path;
          } else if (jsonData.url) {
            setTrainingURL(jsonData.url);
            handleViewTraining(jsonData.url);
          } else if (jsonData.class_number_mismatch) {
            toast.error(jsonData.message);
          }
        },
        onClose: () => {
          try {
            if (modelPath) {
              toast.success(`Training complete, model saved to ${modelPath}`);
            } else {
              toast.warning(`Training incomplete, model may not have saved correctly.`);
            }
          }
          catch (err) {
            console.log(err);
            toast.warning("Training process not completed");
          }
          finally {
            resetExecutableValues();
          }
        }
      });
    }
    catch (err ){
      console.log(err);
      setTraining(false);
      toast.error("Error in training");
    }
  };

  const runTextDetection = (score, spellcheck) => {
    if (training || classification) {
      toast.warning(`Cannot run text detection until current process is complete`);
      return;
    }

    setTextDetection(true);

    let spellcheckCommand = spellcheck ? "True" : "False";
    let tempCocoPath = getTempFilePath("tempLabels.3dl");
    let tempImagePath = getTempFilePath("imagePathsTmp.txt");

    try {
      let jsonData = viewer?.labelObject();
      let imageData = viewer.activeImageLabelPaths();

      let labelJSON = JSON.stringify(jsonData, null, 4);
      let imageJSON = JSON.stringify(imageData, null, 4);

      try {
        fs.writeFileSync(tempImagePath, imageJSON, 'utf8');
        fs.writeFileSync(tempCocoPath, labelJSON, 'utf8');
      } catch(err) {
        console.log(err);
        toast.error(`Failed to export labels for training`);

        setTextDetection(false);
        return;
      }

      let pythonName = "text_from_image";
      let commands = [
        "-p", pythonName,
        "--image_paths_txt", tempImagePath,
        "--coco_data_file", tempCocoPath,
        "--score_threshold", score,
        "--spell_check", spellcheckCommand
      ];

      forceInitialProgress();

      let importData;
      let exe = new PythonExecutable();
      setTrainClassifyExe(exe);

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          updateDownloadingResources(jsonData);

          if (jsonData.cudaError){
            cudaErrorDialog(jsonData.cudaError);
          }

          if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.coco_data) {
            importData = jsonData.coco_data;
          }
        },
        onClose: async () => {
          try {
            if (importData) {
              toast.success(`Text Detection complete, loading labels...`);

              await viewer.loadImageLabelData(importData, setLabelLoadProgress, true, false);
              toast.success(`Labels Loaded Successfully...`);
            } else {
              toast.error(`Error running text detection`);
            }
          }
          catch (err) {
            toast.error(`Error running text detection`);
          }
          finally {
            resetExecutableValues();
          }
        }
      });
    } catch {
      setTextDetection(false);
      toast.error(`Error running classification`);
    }
  };

  const runAerialToLas = (applicationOrder, lasClasses, newLasPath, oldLasPaths, overwriteGround, overwriteFiles, visibleClouds) => {
    if (training || textDetection || classification || classifyingFromAerial) {
      toast.warning(`Cannot run Classify Las from Aerial
        until last process complete is complete`);
      return;
    }

    resetExecutableValues();
    setClassifiyingFromAerial(true);

    let tempCocoPath = getTempFilePath("tempLabels.3dl");
    let tempCloudPath = getTempFilePath("cloudPathTmp.txt");
    let response = null;
    let processTimeout = 1000;

    try {
      let jsonData = viewer?.labelObject();

      let labelJSON = JSON.stringify(jsonData, null, 4);
      let pointJSON = JSON.stringify(oldLasPaths, null, 4);

      try {
        fs.writeFileSync(tempCocoPath, labelJSON, 'utf8');
        fs.writeFileSync(tempCloudPath, pointJSON, 'utf8');
      } catch(err) {
        console.log(err);
        toast.error(`Failed to export labels for Classify Las From Aerial`);

        setClassifiyingFromAerial(false);
        return;
      }

      forceInitialProgress();

      let pythonName = "classify_from_aerial";

      let exe = new PythonExecutable();
      let commands = [
        "-p", pythonName,
        "--cloud_paths_txt", tempCloudPath,
        "--coco_data_file", tempCocoPath,
        "--units", LocalScene.dataProjectionUnits,
        "--overwrite_ground", overwriteGround ? "True" : "False",
        "--overwrite_files", overwriteFiles,
        "--application_order", applicationOrder,
        "--class_map", lasClasses
      ];

      if (!overwriteFiles) {
        commands.push("--outputfolder");
        commands.push(newLasPath);
      }

      setTrainClassifyExe(exe);

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          //updateDownloadingResources(jsonData);

          if (jsonData.label_bounds_error) {
            toast.error("Unable to find any labels inside the defined image bounds");
            setPotentialIssue("Unable to find any labels inside the defined image bounds");
          } else if (jsonData.ErrorRead3DL) {
            toast.error("Error reading .3dl file...");
            setPotentialIssue("Error reading .3dl file...");
          } else if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.overwriteFailure) {
            toast.error('Failed to safely overwrite original file');
            setPotentialIssue('Failed to safely overwrite original file');
          } else if (jsonData.outputFiles) {
            response = jsonData.outputFiles;
          }
        },
        onClose: () => {
          setTimeout(() => {
            if (response) {

              // Delete all old las files
              if (overwriteFiles) {
                visibleClouds.forEach(asset => {
                  dispatch(deleteAsset(asset.id));
                });
              }
              toast.success(`Importing modified files...`);

              // Import modified files
              addPointCloudFiles(dispatch, response, defaultFolder.id);

            }
          }, processTimeout);

          try {
            if (potentialIssue === null) {
              toast.success(`Classification completed successfully`);
            } else {
              toast.warning(`Classification incomplete: ${potentialIssue}`);
            }
          }
          catch (err) {
            console.log(err);
            toast.warning("Classification of Las From Aerial not completed");
          }
          finally {
            resetExecutableValues();
          }
        }
      });
    }
    catch (err ){
      console.log(err);
      setClassifiyingFromAerial(false);
      toast.error("Error in Classification of Las From Aerial");
    }
    setPotentialIssue(null);
  };

  useEffect(() => {
    if (!imageLabelOpen) {
      return;
    }

    const onKeyDown = event => {
      if (event.target instanceof HTMLInputElement) {
        return;
      }

      viewer?.labelHotkey(event);
    };

    window.addEventListener('keydown', onKeyDown, false);

    return () => {
      window.removeEventListener('keydown', onKeyDown, false);
    };
  }, [imageLabelOpen]);

  useEffect(() => {
    ipcRenderer?.removeAllListeners("open-label-ortho");
    ipcRenderer?.on("open-label-ortho", () => {
      handleOpen("ortho");
    });

    ipcRenderer?.removeAllListeners("open-label-scene");
    ipcRenderer?.on("open-label-scene", () => {
      handleOpen("scene");
    });
  }, [viewer, imageLabelOpen, labelType]);

  useEffect(() => {
    viewer?.setActiveLabelType(labelType);

    if (isOrthoLabel) {
      dispatch(changeSwitched(true));
      setModalName("Orthomosaic Training/Classification");
    } else if (isSceneLabel) {
      dispatch(changeSwitched(false));
      setModalName("Panoramic Training/Classification");
    }
  }, [labelType]);

  useEffect(() => {
    if (imageLabelOpen) {
      setDefaultTab();
    } else {
      if (!minimized) {
        setLabelType(null);
      }
      setMinimized(false);
    }

    setTabsEnabled(!imageLabelOpen);
  }, [viewer, imageLabelOpen]);

  useEffect(() => {
    if (minimized) {
      setImageLabelOpen(false);
    }
  }, [minimized]);

  useEffect(() => {
    if (classification) {
      setProcessType("Classification");
    } else if (training) {
      setProcessType("Training");
    } else if (textDetection) {
      setProcessType("Text Detection");
    } else if (classifyingFromAerial){
      setProcessType("Classifying Las from Aerial");
    } else {
      setProcessType("Export");
    }

    if (trainClassifyProgress === 100) {
      setTrainClassifyProgress(0);
    }
  }, [trainClassifyProgress, classification, training]);

  const isTraining = processType === "Training";
  const isModified = categoryList.length !== 0;
  const LASfiles = pointCloudFiles.filter(x => x.type === AssetType.LAS);
  const exportDisabled = viewer?.anyLabelSelected();
  const labelDisabled = classification || training || (labelLoadProgress > 0);
  const trainingLinkDisabled = trainingURL === null;
  const sceneTrainingDisabled = isSceneLabel && (numPanoramics > 0) && (numPlanars > 0);
  const categoryListDisabled = sceneTrainingDisabled;
  const hasTrainingArea = trainingArea.length > 0;
  const visibleClouds = LASfiles.filter(x => x.visible);
  const canMapClassesToLas = (isModified && visibleClouds.length > 0);

  return (
    <React.Fragment>
      <DraggableDialog
        narrow
        minHeight
        open={imageLabelOpen}
        title={modalName}
        onClose={checkClose}
        onMinimize={handleMinimize}
      >

        {/* Label toolbar icons */}
        <IconToolBar margin={1}>

          {/* Add category */}
          <ToolBarButton
            title={"Add Class"}
            icon={"fa-plus-circle"}
            onClick={() => handleCategoryChange(true)}
            success
            disabled={categoryListDisabled}
          />

          {/* Enable training areas */}
          <ToolBarButton
            title={"Enable Training Areas"}
            icon={"fa-square-o"}
            visible={!hasTrainingArea && isOrthoLabel}
            onClick={() => {
              viewer?.addTrainingArea();
            }}
          />

          {/* Disable training areas */}
          <ToolBarButton
            title={"Disable Training Areas"}
            icon={"fa-check-square-o"}
            visible={hasTrainingArea && isOrthoLabel}
            onClick={() => {
              viewer?.deleteTrainingArea();
            }}
          />

          {/* Run Training */}
          <ToolBarButton
            title={"Run Training"}
            icon={"fa-train"}
            onClick={() => {
              if (!canRunTraining()) {
                return;
              }

              setTrainingPrompt(true);
            }}
            disabled={categoryListDisabled || labelDisabled}
          />

          {/* Run Classification */}
          <ToolBarButton
            title={"Run Classification"}
            icon={"fa-object-group"}
            onClick={() => {
              if (!canRunClassification()) {
                return;
              }

              setClassificationPrompt(true);
            }}
            disabled={categoryListDisabled || labelDisabled}
          />

          {/* Classify Las from Classes */}
          <ToolBarButton
            title={"Classify Point Cloud from Aerial"}
            icon={"fa-plane"}
            onClick={() => classifyLas(true)}
            visible={isOrthoLabel}
            disabled={!canMapClassesToLas}
          />

          {/* Import label file */}
          <ToolBarButton
            title={"Import Labels"}
            icon={"fa-upload"}
            onClick={importImageLabels}
            disabled={categoryListDisabled || exportDisabled}
          />

          {/* Export Label file */}
          <ToolBarButton
            title={"Export Labels"}
            icon={"fa-download"}
            onClick={exportImageLabels}
            disabled={categoryListDisabled || exportDisabled}
          />

          {/* Export label intersects */}
          <ToolBarButton
            title={"Label Analysis"}
            icon={"fa-file-excel-o"}
            visible={isSceneLabel}
            onClick={() => {
              setLabelExportOpen(true);
            }}
            disabled={!canExportCSV || exportDisabled}
          />

        </IconToolBar>

        <DenseDivider variant="middle" spacing={5}/>

        {(trainClassifyProgress > 0) && (<React.Fragment>

          <div className={classes.progressToolbar}>

            <ArrowTooltip title={downloadingResources ? "" : `Running ${processType} On Dataset`}>

              {/** Training/Classification progress */}
              <div className={classes.toolbarLinear} style={{
                flex: isTraining ? 8 : 9,
              }}>
                <LinearProgressWithLabel
                  className={classes.toolbarProgressCenter}
                  variant="determinate"
                  value={trainClassifyProgress}
                  color="secondary"
                />
              </div>

            </ArrowTooltip>

            {/** Tensorbard training link */}
            {isTraining && (
              <ToolBarButton
                title={`View Training Progress`}
                icon={"fa-line-chart"}
                disabled={trainingLinkDisabled}
                onClick={() => {
                  handleViewTraining(trainingURL);
                }}
              />
            )}

            {/** Training/Classification cancel button */}
            <ToolBarButton
              title={`Cancel ${processType}`}
              icon={"fa-ban"}
              onClick={handleCancelProgress}
              error
            />
          </div>


        </React.Fragment>)}

        {/** Downloading resources */}
        {(downloadingResources === "download") && (
          <Typography className={classes.downloadMargin} variant="caption" align="center">
            Downloading Resources... <CircularProgress size="1em"/>
          </Typography>
        )}

        {/** Extracting resources */}
        {(downloadingResources === "extract") && (
          <Typography className={classes.downloadMargin} variant="caption" align="center">
            Extracting Resources... <CircularProgress size="1em"/>
          </Typography>
        )}

        {sceneTrainingDisabled && (<Box className={classes.mixedDataWarning}>
          <Typography variant="caption" align="center">
            Image classification is not supported for mixed camera type
            datasets (planar + panoramic). Removing conflicting camera
            files will restore all labelling functionality.
          </Typography>
        </Box>)}

        {(numPlanars > 0) && (<Box className={classes.mixedDataWarning}>
          <Typography variant="caption" align="center">
            Label analysis is disabled for planar images. Removing
            conflicting camera files will restore all labelling functionality.
          </Typography>
        </Box>)}

        {!categoryListDisabled && (<DialogContent className={classes.listContent}>
          <SlimScrollbar>
            {/** Training areas */}
            {hasTrainingArea && (<React.Fragment>
              <List className={classes.formControl}>
                {trainingArea.map(areas =>
                  <TrainingArea
                    key={areas.id}
                    viewer={viewer}
                    trainingArea={areas}
                  />)}
              </List>

              <DenseDivider variant="middle" spacing={5}/>
            </React.Fragment>)}

            {/** Standard categories */}
            <List className={classes.formControl}>
              {categoryList.map(category =>
                <Category
                  key={category.id}
                  viewer={viewer}
                  category={category}
                  isValidCategory={isValidCategory}
                  canRunTraining={canRunTraining}
                  runTextDetection={runTextDetection}
                  isSceneLabel={isSceneLabel}
                />)}
            </List>
          </SlimScrollbar>
        </DialogContent>)}

      </DraggableDialog>

      <TextDialog
        open={addCategory}
        onCancel={handleCancel}
        onSubmit={handleAddCategory}
        title="Create New Class"
        prompt="Enter new class name"
        default=''
        label="Class Name"
        clear={true}
      />

      {/* Close modal */}
      <PromptDialog
        open={closePrompt}
        onCancel={() => setClosePrompt(false)}
        onSubmit={() => {
          handleClose();
          setClosePrompt(false);
        }}
        title="Close Classification Window?"
        prompt={`Do you want to close the ${modalName} window? All created labels will be lost.`}
        button="Close"
      />

      {/* Set training parameters */}
      <TrainingParameters
        open={trainingPrompt}
        setOpen={setTrainingPrompt}
        runTraining={runTraining}
        defaultIterations={'1000'}
      />

      {/* Set classification parameters */}
      <ClassificationParameters
        open={classificationPrompt}
        setOpen={setClassificationPrompt}
        runClassification={runClassification}
        defaultScore={'0.5'}
      />

      {/* Set classify from las parameters */}
      <AerialToLas
        viewer={viewer}
        categories={categoryList}
        setClassifyLasPrompt={setClassifyLasPrompt}
        classifyLasPrompt={classifyLasPrompt}
        pointClouds={pointCloudFiles}
        runAerialToLas={runAerialToLas}
      />

      {/* Image label import percent dialog */}
      <ProgressDialog
        open={labelLoadProgress > 0}
        text={"Importing Image Labels..."}
        percent={labelLoadProgress}
        noTransition
      />

      <Dialog open={readingLabelFile}>
        <DialogContent className={classes.downloadResourceDialog}>
          <Typography className={classes.downloadMargin} variant="caption" align="center">
            Reading Label File... <CircularProgress size="1em"/>
          </Typography>
        </DialogContent>
      </Dialog>

      <Dialog open={downloadResourcesDialog !== ""}>
        <DialogContent className={classes.downloadResourceDialog}>

          {/** Downloading resources (modal) */}
          {(downloadResourcesDialog === "download") && (
            <Typography className={classes.downloadMargin} variant="caption" align="center">
              Downloading Resources... <CircularProgress size="1em"/>
            </Typography>
          )}

          {/** Extracting resources (modal) */}
          {(downloadResourcesDialog === "extract") && (
            <Typography className={classes.downloadMargin} variant="caption" align="center">
              Extracting Resources... <CircularProgress size="1em"/>
            </Typography>
          )}

        </DialogContent>
      </Dialog>

      {/* Modal for importing linework data */}
      <ImportDialog
        viewer={viewer}
        importData={importData}
        setImportData={setImportData}
        categoryList={categoryList}
        isOrthoLabel={isOrthoLabel}
        setLabelLoadProgress={setLabelLoadProgress}
      />

      {/* Modal for exporting label intersections */}
      <LabelIntersectDialog
        open={labelExportOpen}
        setOpen={setLabelExportOpen}
        viewer={viewer}
        forceInitialProgress={forceInitialProgress}
        setTrainClassifyExe={setTrainClassifyExe}
        setTrainClassifyProgress={setTrainClassifyProgress}
        resetExecutableValues={resetExecutableValues}
      />

    </React.Fragment>
  );
};
